import React, { Component } from 'react'
import { connect } from 'react-redux'
import { array } from 'prop-types'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'

class ListSigns extends Component {
  render() {
    return (
      <Table>
        <Thead>
          <Tr>
            <Th>From intersection</Th>
            <Th>Arrow points</Th>
            <Th className="description">Sign description</Th>
          </Tr>
        </Thead>
        <Tbody>
          {this.props.signs.map(sign => (
            <Tr key={sign.properties.id}>
              <Td>{sign.properties.distance_from_intersection} FT</Td>

              <Td
                className={!sign.properties.arrow_points ? 'no-arrow' : 'arrow'}
              >
                {sign.properties.arrow_points || 'N/A'}
              </Td>
              <Td className="description">
                {sign.properties.sign_description}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    )
  }
}

ListSigns.propTypes = {
  signs: array.isRequired,
}

const mapStateToProps = ({ spi }, { signs }) => ({
  theme: spi.theme,
  signs: signs,
})

export default connect(mapStateToProps)(ListSigns)



// WEBPACK FOOTER //
// ./src/components/List/ListSigns/index.jsx